export enum ENofeshType
{
    None = 0,
    NofeshPnim = 1,
    MeurganimPnim = 2,
    NofeshChul = 3, // Nofshon
    MeurganimChul = 4, // Nofesh
    MishpachotChul = 5
}